import Cookies from "js-cookie";
import axiosInstance from "./axiosInstance";

const logout = () => {
    axiosInstance.post('/users/logout');
    Cookies.remove('authToken');
}

export default logout;